import { motion } from "framer-motion";
import { Music, Send } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PostCard } from "@/components/PostCard";

export const ArtistPostsTab = ({
  posts,
  setPosts,
  isOwner,
  newPost,
  setNewPost,
  postLoading,
  handleCreatePost,
  handleLike,
  handleReact,
}) => {
  return (
    <motion.div
      key="posts"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className="space-y-4"
    >
      {isOwner && (
        <form onSubmit={handleCreatePost} className="bg-card border border-border rounded-3xl p-5 space-y-3 shadow-sm" data-testid="create-post-form">
          <h3 className="font-heading font-bold text-sm text-card-foreground">Publier</h3>
          <textarea
            placeholder="Quoi de neuf ?"
            value={newPost.content}
            onChange={(e) => setNewPost({ ...newPost, content: e.target.value })}
            className="w-full bg-white border border-border rounded-xl px-4 py-3 text-sm text-card-foreground placeholder:text-muted-foreground focus:border-[#FF6B35] outline-none resize-none h-24"
            data-testid="post-content-input"
          />
          <Input
            placeholder="Lien YouTube, Spotify, SoundCloud... (optionnel)"
            value={newPost.embed_url}
            onChange={(e) => setNewPost({ ...newPost, embed_url: e.target.value })}
            className="bg-white border-border rounded-xl text-card-foreground placeholder:text-muted-foreground h-10 text-sm"
            data-testid="post-embed-input"
          />
          <button
            type="submit"
            disabled={postLoading || (!newPost.content.trim() && !newPost.embed_url.trim())}
            className="bg-[#FF6B35] text-white font-bold px-6 py-2.5 rounded-full text-sm hover:scale-105 active:scale-95 transition-transform duration-200 disabled:opacity-50 flex items-center gap-2"
            data-testid="post-submit-btn"
          >
            <Send className="w-4 h-4" />
            {postLoading ? "..." : "Publier"}
          </button>
        </form>
      )}

      {posts.length === 0 ? (
        <div className="text-center py-12">
          <Music className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Aucune publication</p>
        </div>
      ) : (
        posts.map((p, i) => (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
          >
            <PostCard
              post={p}
              onLike={handleLike}
              onReact={handleReact}
              onDelete={(id) => setPosts((prev) => prev.filter((x) => x.id !== id))}
              onUpdate={(id, updated) => setPosts((prev) => prev.map((x) => x.id === id ? { ...x, ...updated } : x))}
              onHide={(id) => setPosts((prev) => prev.filter((x) => x.id !== id))}
              onBlock={(artistId) => setPosts((prev) => prev.filter((x) => x.artist_id !== artistId))}
            />
          </motion.div>
        ))
      )}
    </motion.div>
  );
};
